import React from 'react';
import Skeleton from 'components/general/Skeleton/Skeleton';

const SkeletonBanner = () => (
  <div className="banner">
    <div className="banner__message">
      <Skeleton width={[100, 200]} />
    </div>
  </div>
);

export default SkeletonBanner;
